var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDirectionsCarBlack24Dp = function SvgDirectionsCarBlack24Dp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#directions_car_black_24dp_svg__a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.92 6.176c-.2-.59-.76-1.01-1.42-1.01h-11c-.66 0-1.21.42-1.42 1.01L3 12.166v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99Zm-12.07.99h10.29l1.08 3.11H5.77l1.08-3.11Zm12.15 10H5v-5h14v5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 16.166a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM16.5 16.166a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "directions_car_black_24dp_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .166)",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgDirectionsCarBlack24Dp;